import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, QueryList, ViewChildren, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FieldErrorState } from '../text-input/field-id';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'ngx-text-list-input',
  templateUrl: './text-list-input.component.html',
  styleUrls: ['./text-list-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextListInputComponent),
      multi: true,
    },
  ],
})
export class TextListInputComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() require = false;
  @Input() pattern = '';
  @Input() patternError = '';
  @Input() label = '';
  @Input() fireAlert = false;
  @Input() readonly = false;
  key: string = '';

  @ViewChildren('field') fieldModels: QueryList<NgModel>;
  private rowsSubscription: Subscription;

  /** Settled per-row error flags shared by aria-invalid, aria-describedby and the error message. */
  readonly errorState = new FieldErrorState(
    () => this.cdr.markForCheck(),
    (model) => !!(model?.errors && (model.touched || this.fireAlert))
  );

  constructor(private cdr: ChangeDetectorRef) {
    this.key = this.generateRandomKey(5);
  }

  _inputValue: string[] = [];
  get inputValue(): string[] {
    return this._inputValue;
  }
  set inputValue(val) {
    this._inputValue = val && val.length > 0 ? val : [null];
    this.propagateChange(this._inputValue);
  }

  propagateChange = (_: any) => { };
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched() { }
  writeValue(value: any) {
    this.inputValue = value;
  }

  ngOnInit() { }

  get labelId(): string {
    return `field-${this.key}-label`;
  }

  fieldId(index: number): string {
    return `field-${this.key}${index}`;
  }

  errorId(index: number): string {
    return `${this.fieldId(index)}-error`;
  }

  errorShown(index: number): boolean {
    return this.errorState.shown[index] ?? false;
  }

  ngOnChanges(): void {
    this.errorState.schedule();
  }

  ngAfterViewInit(): void {
    this.errorState.watch(this.fieldModels.toArray());
    this.rowsSubscription = this.fieldModels.changes.subscribe(() => this.errorState.watch(this.fieldModels.toArray()));
  }

  ngOnDestroy(): void {
    this.rowsSubscription?.unsubscribe();
    this.errorState.destroy();
  }

  addItem(): void {
    this.inputValue.push(null);
  }

  removeItem(index: number): void {
    this.inputValue.splice(index, 1);
  }

  onChange(index: number, e: any) {
    this.inputValue[index] = e.target.value;
  }
  generateRandomKey(length: number): string {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomValues = new Uint32Array(length);
    const randomChars = [];

    window.crypto.getRandomValues(randomValues);
    for (let i = 0; i < length; i++) {
      randomChars.push(charset[randomValues[i] % charset.length]);
    }

    return randomChars.join('');
  }
}
